import React, { useState, useEffect } from 'react';
import Loader from './loader/Loader';
import { policies } from '../apis/WebServices';
import { sanitize } from '../utils/sanitizeHtml';

const TermsOfUse = () => {
  const [terms, setTerms] = useState(null);
  const [loading, setLoading] = useState(true);
  const [termsParts, setTermsParts] = useState([]);

  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;

  const fetchTerms = async () => {
    try {
      const response = await policies();
      if (response?.isSuccess) {
        const filtered = response?.data?.filter(item => item?.type === "terms and Conditions");
        setTerms(filtered);
      }
    } catch (error) {
      console.error("Error fetching terms:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTerms();
  }, []);

  useEffect(() => {
    if (terms && terms[0]?.content) {
      const content = terms[0].content;

      let paragraphs = content.split(/<\/p>/i)
        .map(p => p.trim())
        .filter(p => p !== "")
        .map(p => p + "</p>");

      if (isMobile) {
        setTermsParts([paragraphs.join('')]);
        return;
      }
      let part1 = [];
      let part2 = [];
      let len1 = 0;
      let len2 = 0;

      paragraphs.forEach(p => {
        if (len1 <= len2) {
          part1.push(p);
          len1 += p.length;
        } else {
          part2.push(p);
          len2 += p.length;
        }
      });

      setTermsParts([part1.join(''), part2.join('')]);
    }
  }, [terms, isMobile]);

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <style>
        {`
          .terms-content * {
            color: #ffffff !important;
          }
          .terms-content p,
          .terms-content span,
          .terms-content div,
          .terms-content h1,
          .terms-content h2,
          .terms-content h3,
          .terms-content h4,
          .terms-content h5,
          .terms-content h6,
          .terms-content li,
          .terms-content ul,
          .terms-content ol,
          .terms-content strong,
          .terms-content em,
          .terms-content b,
          .terms-content i {
            color: #ffffff !important;
          }
        `}
      </style>
      <div className='whole-div' style={{ minHeight: "100vh" }}>
        <div className='container-fluid'>
          <div className="page-content">
          <div className="row dash-nft">
            <div className="d-flex align-items-center justify-content-between">
              <h4 className="mb-3 text-white">Terms & Conditions</h4>
            </div>

            <div className="col-lg-6">
              <div className="term-para">
                <div
                  className="text-white terms-content"
                  style={{ color: "#ffffff" }}
                  dangerouslySetInnerHTML={{ __html: sanitize(termsParts[0]) }}
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="term-para">
                <div
                  className="text-white terms-content"
                  style={{ color: "#ffffff" }}
                  dangerouslySetInnerHTML={{ __html: sanitize(termsParts[1]) }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default TermsOfUse;
